import * as React from 'react';
import { Form, Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Bruger } from '../../models/Bruger';
import { TextFormGroup, EmailFormGroup, DropDownFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { getLoggedInBruger, erElev } from '../../infrastructure/Security';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { Hold } from '../../models/Hold';
import { Spinner } from '../../uiComponents/Spinner';
import { getHoldListFromCache, setHoldListCache } from '../../infrastructure/HoldListCache';
import { Institution } from '../../models/Institution';
import { isNullOrUndefined } from '../../infrastructure/ValidationHelper';

export interface BrugerEditProps {
    onBrugerSaved: (bruger: Bruger) => void;
    isSubmitting: boolean;
}

export interface BrugerEditState {
    bruger: Bruger;
    errorMessages: ValidationError[];
    holdList?: Hold[];
    institutionList?: Institution[];
}

class BrugerEdit extends React.Component<BrugerEditProps, BrugerEditState> {
    constructor(props: BrugerEditProps) {
        super(props);

        let bruger = getLoggedInBruger();
        if (!isNullOrUndefined(bruger.institutionsNummer) && bruger.institutionsNummer === '') {
            bruger.gruppeId = '';
        }

        this.state = { bruger: bruger, errorMessages: [] };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        if (this.state.bruger.rolle === BrugerRolleEnum.Elev) {
            const self = this;
            let holdList = getHoldListFromCache();
            self.setState({ holdList: holdList });

            let caller = createApiCaller();
            caller.getInstitutionerForBruger().then(response => {
                self.setState({ institutionList: response });
            });
        }
    }

    handleSubmit() {
        const self = this;
        const apiCaller = createApiCaller();
        apiCaller.updateBruger(this.state.bruger).then((response: any) => {
            if (response.token !== undefined) {
                if (this.state.bruger.rolle !== BrugerRolleEnum.Ekstern) {
                    apiCaller.getHoldList().then(hold => {
                        setHoldListCache(hold);
                        self.handleSubmitSuccess(response);
                    });
                } else {
                    self.handleSubmitSuccess(response);
                }
            } else {
                self.setState({ errorMessages: response.errorMessages });
            }
        });
    }

    handleSubmitSuccess(response: any) {
        localStorage.setItem('token', response.token);
        this.setState({ errorMessages: [] });
        this.props.onBrugerSaved(this.state.bruger);
    }

    institutionOnChange = (fieldName: string, value: any) => {
        const bruger = this.state.bruger;
        bruger.institutionsNummer = value;
        bruger.gruppeId = '';
        this.setState({ bruger: bruger });
    }

    handleChange(fieldName: string, value: any) {
        const bruger = this.state.bruger;
        bruger[fieldName] = value;
        this.setState({ bruger: bruger });
    }

    render() {
        let holdItems: MenuItemDto[] = [];
        let institutionItems: MenuItemDto[] = [];

        if (this.state.institutionList !== undefined) {
            institutionItems = this.state.institutionList.map(i => new MenuItemDto(i.institutionsnummer, i.navn));
        }

        if (this.state.bruger.institutionsNummer !== undefined && this.state.bruger.institutionsNummer !== null && this.state.bruger.institutionsNummer.length > 0) {
            if (this.state.holdList !== undefined) {
                let hold = this.state.holdList.filter(h => h.institution.institutionsnummer === this.state.bruger.institutionsNummer);
                holdItems = hold.map(h => new MenuItemDto(h.gruppeId, h.institution.navn + ' - ' + h.navn));
            }
        }

        if (institutionItems.length === 0 && this.state.bruger.rolle === BrugerRolleEnum.Elev) {
            return <Spinner />;
        } else {
            return (
                <Row>
                    <Col md={6}>
                        <Form onSubmit={this.handleSubmit}>
                            {this.state.institutionList !== undefined &&
                                <DropDownFormGroup
                                    items={institutionItems}
                                    name='institutionsNummer'
                                    label='Institution'
                                    ingenValgtText='Vælg institution'
                                    selectedValue={this.state.bruger.institutionsNummer || ''}
                                    onChange={this.institutionOnChange}
                                />
                            }

                            {this.state.holdList !== undefined &&
                                <DropDownFormGroup
                                    items={holdItems}
                                    name='gruppeId'
                                    label='Hold'
                                    ingenValgtText='Vælg hold'
                                    disabled={this.state.bruger.institutionsNummer === undefined || this.state.bruger.institutionsNummer === null || this.state.bruger.institutionsNummer.length === 0}
                                    selectedValue={this.state.bruger.gruppeId || ''}
                                    onChange={this.handleChange}
                                />
                            }

                            <TextFormGroup
                                errorMessages={this.state.errorMessages}
                                label='Navn*'
                                name='navn'
                                placeholder='Fulde navn'
                                value={this.state.bruger.navn || ''}
                                onChange={this.handleChange}
                            />

                            {!erElev() &&
                                <EmailFormGroup
                                    errorMessages={this.state.errorMessages}
                                    label='E-mail*'
                                    name='email'
                                    placeholder='E-mail du kan kontaktes på'
                                    value={this.state.bruger.email || ''}
                                    onChange={this.handleChange}
                                />
                            }

                            <SubmitButton isSubmitting={this.props.isSubmitting}>Gem</SubmitButton>
                        </Form>
                    </Col>
                </Row>
            );
        }
    }
}

export default BrugerEdit;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/bruger/BrugerEdit.tsx